/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { uifBacklogResource } from '@jira/router-resources__classic-projects-uif-backlog/src/uifBacklogResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { boardDataResource } from './boardDataResource.tsx';
import { rapidboardResource } from './rapidboardResource.tsx';
import { wrmBundleResource } from './wrmBundleResource.tsx';

export const shouldLoadUIFBoardResources = (): boolean => !__SERVER__;
export const shouldLoadLegacyBoardResources = (): boolean => !shouldLoadUIFBoardResources();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRapidboardResources = (): RouteResource<any>[] => [
	wrmBundleResource,
	resourceWithCondition(shouldLoadLegacyBoardResources, rapidboardResource),
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRapidBoardDataResource = (): RouteResource<any> => boardDataResource;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUIFBacklogDataResource = (): RouteResource<any>[] => [
	resourceWithCondition(
		() =>
			!fg('jira_backlog_use_agg_data') &&
			(shouldLoadUIFBoardResources() || fg('enable_ssr_for_cmp_backlog')),
		uifBacklogResource,
	),
];
